module.exports = __webpack_public_path__ + "static/clicks-a34eed7a0a25987ec5908b6859ea17cb.png";